"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const spacing = {
    offset3xs: '2px',
    offset2xs: '4px',
    offsetXs: '8px',
    offsetSm: '12px',
    offsetMd: '16px',
    offsetLg: '24px',
    offsetXl: '32px',
    offset2xl: '40px',
    offset3xl: '48px',
    offset4xl: '64px',
};
exports.default = spacing;
